/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_Choose_Plan_TitleInputs */

const en_directory_submit_review_choose_plan_title = /** @type {(inputs: Directory_Submit_Review_Choose_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose how this draft enters review`)
};

const zh_directory_submit_review_choose_plan_title = /** @type {(inputs: Directory_Submit_Review_Choose_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择草稿进入审核的方式`)
};

/**
* | output |
* | --- |
* | "Choose how this draft enters review" |
*
* @param {Directory_Submit_Review_Choose_Plan_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_choose_plan_title = /** @type {((inputs?: Directory_Submit_Review_Choose_Plan_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_Choose_Plan_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_choose_plan_title(inputs)
	return zh_directory_submit_review_choose_plan_title(inputs)
});
export { directory_submit_review_choose_plan_title as "directory.submit.review.choose_plan_title" }